import { Flex } from "@chakra-ui/react";
import { Col, Row } from "antd";
import ContentItem from "components/ContentItem";
import { PrevisaoOrcamentaria } from "core/features/previsao-orcamentaria/typings";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";

interface DescriticaoContaProps {
  item: PrevisaoOrcamentaria;
}

export default function DescricaoConta({ item }: DescriticaoContaProps) {
  return (
    <Flex w="100%" flexDir="column" gap={4} px={4}>
      <Row gutter={8}>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Ano"
            descricao={moment(item.dataInicio).format("YYYY")}
          />
        </Flex>
        <Flex as={Col} xs={6}>
          <ContentItem titulo="Descrição" descricao={item.nome} />
        </Flex>
        <Flex as={Col} xs={5}>
          <ContentItem
            titulo="Data de Criação"
            descricao={moment(item.createdAt).format("DD/MM/YYYY")}
          />
        </Flex>
        <Flex as={Col} xs={7}>
          <ContentItem
            titulo="Taxa de inadimplência prevista "
            descricao={`${item.taxaInadimplenciaPrevista}%`}
          />
        </Flex>
      </Row>
      <Row gutter={8}>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Previsão de Receitas"
            descricao={formatMoney(item.previsao.receita || 0)}
          />
        </Flex>
        <Flex as={Col} xs={10}>
          <ContentItem
            titulo="Previsão de Despesas"
            descricao={formatMoney(item.previsao.despesa || 0)}
          />
        </Flex>
      </Row>
    </Flex>
  );
}
